import './App.css'
import ThemeContainer from './Theme'
import { Provider } from "react-redux"
import store from './Redux/store'

import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: 'ease-out-cubic',
    })
  }, [])

  return (
    <Provider store={store}>
      <ThemeContainer />
    </Provider>
  )
}

export default App